import { render, staticRenderFns } from "./ProjectAnnulationInfo.vue?vue&type=template&id=501ea9c1&scoped=true&"
import script from "./ProjectAnnulationInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectAnnulationInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAnnulationInfo.vue?vue&type=style&index=0&id=501ea9c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501ea9c1",
  null
  
)

export default component.exports